import { useCallback } from 'react';

import AccountSettings from '@app/views/AccountSettings';
import { useNavigate } from '@app/hooks';

import { PlanLink, StackLink } from '../constants';

export const AccountSettingsSwitch = (): JSX.Element => {
  const { goTo } = useNavigate();

  const navigateToChangePlan = useCallback(() => {
    goTo(`${PlanLink.Plan}/${PlanLink.ChoosePlanFilter}`);
  }, [goTo]);

  const navigateToScheduleInstallation = useCallback(() => {
    goTo(StackLink.ScheduleInstallation);
    return;
  }, [goTo]);

  return (
    <AccountSettings
      navigateToChangePlan={navigateToChangePlan}
      navigateToScheduleInstallation={navigateToScheduleInstallation}
    />
  );
};
